import { render, staticRenderFns } from "./admin-ope.vue?vue&type=template&id=152fb96c&scoped=true&"
import script from "./admin-ope.vue?vue&type=script&lang=js&"
export * from "./admin-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152fb96c",
  null
  
)

export default component.exports